import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SubscriptionOrderModel } from '../../../../shared/models/subscription-order.model';

@Component({
    selector: 'account-subscriptions-details-orders',
    templateUrl: './account.subscriptions.details.orders.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsOrdersComponent {
    @Input('orders') orders: Array<SubscriptionOrderModel>;
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/subscriptions/details/orders/account.subscriptions.details.orders.component.ts